
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'

@Component({
    mixins: [UserMixin],
})
export default class UserIndex extends Mixins<MixinInterface>(UserMixin) {
    @Watch('isImpersonating', { immediate: true })
    async getData() {
        if (this.currentUser) {
            if (this.currentUser.attributes.frontEndSettings) {
                this.$store.commit(
                    'frontEndSettings',
                    JSON.parse(this.currentUser.attributes.frontEndSettings)
                )
            }
        }
    }
}
